import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'ccd-remove-dialog',
  template: require('./remove-dialog.component.html'),
  styles: [require('../action-dialog.component.scss')]
})
export class RemoveDialogComponent {

  result: string;

  constructor(private matDialogRef: MatDialogRef<RemoveDialogComponent>) {}

  remove() {
    this.result = 'Remove';
    this.matDialogRef.close(this.result);
  }
  cancel() {
    this.result = 'Cancel';
    this.matDialogRef.close(this.result);
  }
}
